// Minimal product telemetry. Currently a safe no-op sink (Firebase Analytics was
// removed — we don't use Firebase). The public `track` API is kept so call sites
// stay unchanged and a real sink can be wired in later behind it.
// RULES: event names + coarse dimensions only — NEVER amounts, identifiers, or
// anything personal/financial.

export function track(_event: string, _params?: Record<string, string | number | boolean>): void {
  // Intentionally a no-op. Telemetry must never break the app.
}
